module.exports = __webpack_public_path__ + "img/piggy-punks-poster.0ac19757.webp";